const mobileUserAgentPattern = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Tablet/i;

export function isMobileBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;

  const navigatorWithHints = navigator as Navigator & {
    userAgentData?: { mobile?: boolean };
  };
  if (navigatorWithHints.userAgentData?.mobile === true) return true;
  if (mobileUserAgentPattern.test(navigator.userAgent)) return true;

  // iPadOS can identify itself as desktop Safari.
  return /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
}

export function shouldUseMobileExperience(breakpoint = 768): boolean {
  if (typeof window === 'undefined') return false;
  return isMobileBrowser() || window.innerWidth < breakpoint;
}
